import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Button.module.sass';

const Button = ({ children, bold = false, variant, classes, fullWidth, circular = false, rounded = false, disabled, size, type = 'submit', style = {}, onClick, ...props }) => {
  const buttonClasses = {
    [styles.btn]: true,
    [styles[`${variant}`]]: variant,
    [styles.fullWidth]: fullWidth,
    [styles[`${size}`]]: size,
    [classes]: !!classes,
    [styles.rounded]: rounded,
    [styles.circular]: circular,
    [styles.bold]: bold,
  };

  return (
    <button
      className={cn(buttonClasses)}
      disabled={disabled}
      onClick={onClick}
      style={style}
      type={type}
      {...props}
    >
      {children}
    </button>
  )
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  classes: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.oneOf(['primary', 'submit', 'link', 'dark', 'error']),
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  rounded: PropTypes.bool,
  circular: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'button', 'reset'])
};

export default Button;
